import { render, staticRenderFns } from "./EditTitle.vue?vue&type=template&id=670013de&scoped=true"
import script from "./EditTitle.vue?vue&type=script&lang=js"
export * from "./EditTitle.vue?vue&type=script&lang=js"
import style0 from "./EditTitle.vue?vue&type=style&index=0&id=670013de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670013de",
  null
  
)

export default component.exports